import { render } from "./Avaliation360.vue?vue&type=template&id=87494eca"
import script from "./Avaliation360.vue?vue&type=script&lang=js"
export * from "./Avaliation360.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__